export default "__VITE_ASSET__DBXZK8o1__"